"use client";

import dynamic from "next/dynamic";
import { JSX } from "react";

const HomeLanding = dynamic(
  () =>
    import("@/components/landing/HomeLanding").then((m) => ({
      default: m.HomeLanding,
    })),
  {
    ssr: false,
    loading: () => (
      <div
        className="flex min-h-[100dvh] items-center justify-center bg-[#03050a] text-slate-400"
        aria-busy="true"
        aria-label="Loading"
      >
        <span className="font-majormono text-xs lowercase tracking-[0.35em]">Initializing…</span>
      </div>
    ),
  }
);

export default function HomePageClient(): JSX.Element {
  return <HomeLanding />;
}
